import ee from "./objectWithoutPropertiesLoose.mjs";
import r from "./extends.mjs";
import * as d from "react";
import { clsx as te } from "./clsx.mjs";
import e from "./index180.mjs";
import b from "./styled.mjs";
import ne from "./useThemeProps.mjs";
import { duration as oe } from "./createTransitions.mjs";
import { getTransitionProps as M } from "./utils10.mjs";
import ie from "./useTheme.mjs";
import { getCollapseUtilityClass as re } from "./collapseClasses.mjs";
import { jsx as z } from "react/jsx-runtime";
import se from "./Transition.mjs";
import ae from "./useForkRef.mjs";
import le from "./elementTypeAcceptingRef.mjs";
import pe from "./composeClasses.mjs";
const ce = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], de = (o) => {
  const {
    orientation: n,
    classes: s
  } = o, u = {
    root: ["root", `${n}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${n}`],
    wrapperInner: ["wrapperInner", `${n}`]
  };
  return pe(u, re, s);
}, ue = b("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (o, n) => {
    const {
      ownerState: s
    } = o;
    return [n.root, n[s.orientation], s.state === "entered" && n.entered, s.state === "exited" && !s.in && s.collapsedSize === "0px" && n.hidden];
  }
})(({
  theme: o,
  ownerState: n
}) => r({
  height: 0,
  overflow: "hidden",
  transition: o.transitions.create("height")
}, n.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: o.transitions.create("width")
}, n.state === "entered" && r({
  height: "auto",
  overflow: "visible"
}, n.orientation === "horizontal" && {
  width: "auto"
}), n.state === "exited" && !n.in && n.collapsedSize === "0px" && {
  visibility: "hidden"
})), me = b("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (o, n) => n.wrapper
})(({
  ownerState: o
}) => r({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, o.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), fe = b("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (o, n) => n.wrapperInner
})(({
  ownerState: o
}) => r({
  width: "100%"
}, o.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), S = /* @__PURE__ */ d.forwardRef(function(n, s) {
  const u = ne({
    props: n,
    name: "MuiCollapse"
  }), {
    addEndListener: $,
    children: _,
    className: U,
    collapsedSize: E = "0px",
    component: V,
    easing: D,
    in: O,
    onEnter: N,
    onEntered: W,
    onEntering: L,
    onExit: j,
    onExited: k,
    onExiting: P,
    orientation: A = "vertical",
    style: v,
    timeout: l = oe.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: q = se
  } = u, B = ee(u, ce), x = r({}, u, {
    orientation: A,
    collapsedSize: E
  }), m = de(x), F = ie(), H = d.useRef(), p = d.useRef(null), C = d.useRef(), y = typeof E == "number" ? `${E}px` : E, f = A === "horizontal", h = f ? "width" : "height";
  d.useEffect(() => () => {
    clearTimeout(H.current);
  }, []);
  const w = d.useRef(null), G = ae(s, w), c = (t) => (i) => {
    if (t) {
      const a = w.current;
      i === void 0 ? t(a) : t(a, i);
    }
  }, R = () => p.current ? p.current[f ? "clientWidth" : "clientHeight"] : 0, J = c((t, i) => {
    p.current && f && (p.current.style.position = "absolute"), t.style[h] = y, N && N(t, i);
  }), K = c((t, i) => {
    const a = R();
    p.current && f && (p.current.style.position = "");
    const {
      duration: g,
      easing: T
    } = M({
      style: v,
      timeout: l,
      easing: D
    }, {
      mode: "enter"
    });
    if (l === "auto") {
      const I = F.transitions.getAutoHeightDuration(a);
      t.style.transitionDuration = `${I}ms`, C.current = I;
    } else
      t.style.transitionDuration = typeof g == "string" ? g : `${g}ms`;
    t.style[h] = `${a}px`, t.style.transitionTimingFunction = T, L && L(t, i);
  }), Q = c((t, i) => {
    t.style[h] = "auto", W && W(t, i);
  }), X = c((t) => {
    t.style[h] = `${R()}px`, j && j(t);
  }), Y = c(k), Z = c((t) => {
    const i = R(), {
      duration: a,
      easing: g
    } = M({
      style: v,
      timeout: l,
      easing: D
    }, {
      mode: "exit"
    });
    if (l === "auto") {
      const T = F.transitions.getAutoHeightDuration(i);
      t.style.transitionDuration = `${T}ms`, C.current = T;
    } else
      t.style.transitionDuration = typeof a == "string" ? a : `${a}ms`;
    t.style[h] = y, t.style.transitionTimingFunction = g, P && P(t);
  });
  return /* @__PURE__ */ z(q, r({
    in: O,
    onEnter: J,
    onEntered: Q,
    onEntering: K,
    onExit: X,
    onExited: Y,
    onExiting: Z,
    addEndListener: (t) => {
      l === "auto" && (H.current = setTimeout(t, C.current || 0)), $ && $(w.current, t);
    },
    nodeRef: w,
    timeout: l === "auto" ? null : l
  }, B, {
    children: (t, i) => /* @__PURE__ */ z(ue, r({
      as: V,
      className: te(m.root, U, {
        entered: m.entered,
        exited: !O && y === "0px" && m.hidden
      }[t]),
      style: r({
        [f ? "minWidth" : "minHeight"]: y
      }, v),
      ownerState: r({}, x, {
        state: t
      }),
      ref: G
    }, i, {
      children: /* @__PURE__ */ z(me, {
        ownerState: r({}, x, {
          state: t
        }),
        className: m.wrapper,
        ref: p,
        children: /* @__PURE__ */ z(fe, {
          ownerState: r({}, x, {
            state: t
          }),
          className: m.wrapperInner,
          children: _
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (S.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: e.func,
  /**
   * The content node to be collapsed.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: e.oneOfType([e.number, e.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: le,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: e.oneOfType([e.shape({
    enter: e.string,
    exit: e.string
  }), e.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: e.bool,
  /**
   * @ignore
   */
  onEnter: e.func,
  /**
   * @ignore
   */
  onEntered: e.func,
  /**
   * @ignore
   */
  onEntering: e.func,
  /**
   * @ignore
   */
  onExit: e.func,
  /**
   * @ignore
   */
  onExited: e.func,
  /**
   * @ignore
   */
  onExiting: e.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: e.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: e.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: e.oneOfType([e.oneOf(["auto"]), e.number, e.shape({
    appear: e.number,
    enter: e.number,
    exit: e.number
  })])
});
S.muiSupportAuto = !0;
const Ne = S;
export {
  Ne as default
};
//# sourceMappingURL=Collapse.mjs.map
